export const keyframes = {
    "shake-h": {
        "0%": { transform: "translateX(0)" },
        "25%": { transform: "translateX(5px)" },
        "50%": { transform: "translateX(-5px)" },
        "75%": { transform: "translateX(5px)" },
        "100%": { transform: "translateX(0)" },
    },
    "shake-h-hover": {
        "0%": { transform: "translateX(0)" },
        "25%": { transform: "translateX(5px)" },
        "50%": { transform: "translateX(-5px)" },
        "75%": { transform: "translateX(5px)" },
        "100%": { transform: "translateX(0)" },
    },
};
export const animation = {
    "shake-h": "shake-h 0.5s linear",
    "shake-h-hover": "shake-h-hover 0.5s reverse 1",
};
/**
 * Converts the keyframes from a classic Tailwind animation into a CSS config
 * ready version
 *
 * @param name The name of the animation.
 * @param values The keyframe data
 * @returns The css config ready version.
 */
export function getKeyframesAsAtRule(name, values) {
    let content = "";
    const entries = Object.entries(values);
    for (const [percentage, styles] of entries) {
        // Start the percentage block
        content += `${percentage} {\n`;
        // Process each style property
        for (const [prop, value] of Object.entries(styles)) {
            // Convert camelCase property names to hyphen-case (e.g., backgroundColor -> background-color)
            const hyphenProp = prop.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
            // Convert camelCase function names in values to hyphen-case (e.g., translateX -> translate-x)
            const processedValue = String(value)
                .replace(/([a-z])([A-Z])/g, "$1-$2")
                .toLowerCase();
            content += `${hyphenProp}: ${processedValue};\n`;
        }
        // Close the percentage block
        content += `}\n`;
    }
    // Remove the trailing newline for cleanliness
    content = content.trimEnd();
    return { content, name, ruleType: "keyframes" };
}
export const keyframesAtRules = Object.entries(keyframes).map(([name, values]) => getKeyframesAsAtRule(name, values));
//# sourceMappingURL=animations.js.map